import { render, staticRenderFns } from "./ContractorsWithMailSubscription.vue?vue&type=template&id=0487ca70&scoped=true&"
import script from "./ContractorsWithMailSubscription.vue?vue&type=script&lang=js&"
export * from "./ContractorsWithMailSubscription.vue?vue&type=script&lang=js&"
import style0 from "./ContractorsWithMailSubscription.vue?vue&type=style&index=0&id=0487ca70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487ca70",
  null
  
)

export default component.exports